var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class VirtualDisplay {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.defaultVideoSource = '1';
        this.defaultVolume = 50;
        this.defaultVolumeMute = false;
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`INPUT ?`, /(\d+)/i, tags);
                    return match[1] ? match[1] : this.state.videoInput.value;
                }
                catch (err) {
                    return this.defaultVideoSource;
                }
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`INPUT ${code}`, /(OK|ERR)/i, tags);
                    return match[1].toLowerCase() === 'ok' ? code : this.state.videoInput.value;
                }
                catch (err) {
                    return code;
                }
            }),
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`VOLUME ?`, /(\d+)/i, tags);
                    return match[1] ? parseInt(match[1], 10) : this.state.volume.value;
                }
                catch (err) {
                    return this.defaultVolume;
                }
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`VOLUME ${volume}`, /(OK|ERR)/i, tags);
                    return match[1].toLowerCase() === 'ok' ? volume : this.state.volume.value;
                }
                catch (err) {
                    return volume;
                }
            }),
            range: { max: 100, min: 0, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`MUTE ?`, /\d+/i, tags);
                    return match[1] ? parseInt(match[1], 10) === 1 : this.state.volumeMute.value;
                }
                catch (err) {
                    return this.defaultVolumeMute;
                }
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const match = yield this.socket.send(`MUTE ${mute ? '1' : '0'}`, /(OK|ERR)/i, tags);
                    return match[1].toLowerCase() === 'ok' ? mute : this.state.volumeMute.value;
                }
                catch (err) {
                    return mute;
                }
            }),
        };
    }
    // phase callbacks
    onConfigure(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const videoInputCodes = Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {}).map(v => v.code);
            if (!videoInputCodes.includes(this.defaultVideoSource)) {
                this.defaultVideoSource = videoInputCodes.length > 0 ? videoInputCodes[0] : '1';
            }
        });
    }
}
// static properties
VirtualDisplay.driverType = 'socketDriver';
VirtualDisplay.key = '-N30OglJJ5KY5zaoIr4R';
// Allow the virtual display driver to operate even if it is not simulated.
VirtualDisplay.socketOptions = [
    { allowNoConnection: true, idleTimeoutMs: 0, port: 5000 },
];
